module.exports = __webpack_public_path__ + "assets/bfdc638d0830c2380ad5d5c7909e7029.png";